import script from "./NewOrderView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewOrderView.vue?vue&type=script&setup=true&lang=js"

import "./NewOrderView.vue?vue&type=style&index=0&id=2ae04aae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ae04aae"]])

export default __exports__